import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable, switchMap } from 'rxjs';
import { BoschUiCellDefDirective } from './directives/bosch-ui-cell-def.directive';
import { BoschUiHeaderCellDefDirective } from './directives/bosch-ui-header-cell-def.directive';
import { BoschUiTableDataSource } from './entities/bosch-ui-table-data-source.entity';

@Injectable()
export class BoschUiTableService<DataType> {
  set dataSource(dataSource: BoschUiTableDataSource<DataType> | DataType[] | null) {
    if (dataSource) {
      this._dataSource = Array.isArray(dataSource) ? new BoschUiTableDataSource<DataType>(dataSource) : dataSource;
      this._ready$.next(true);
    }
  }
  get dataSource(): BoschUiTableDataSource<DataType> {
    return this._dataSource;
  }

  private _dataSource!: BoschUiTableDataSource<DataType>;
  private _cells = new Map<string, BoschUiCellDefDirective<DataType> | null>();
  private _headerCells = new Map<string, BoschUiHeaderCellDefDirective<DataType> | null>();
  private _displayedColumns: string[] = [];
  private _headerDisplayedColumns: string[] = [];
  private _ready$ = new BehaviorSubject<boolean>(false);

  data$: Observable<DataType[]> = this._ready$.pipe(
    filter(Boolean),
    switchMap(() => this._dataSource.data$),
  );

  createRowCells(columns: string[]): void {
    this._displayedColumns = [...this._displayedColumns, ...columns];

    this._displayedColumns.forEach((column: string) => {
      this._cells.set(column, null);
    });
  }

  createHeaderRowCells(columns: string[]): void {
    this._headerDisplayedColumns = columns;

    this._headerDisplayedColumns.forEach((column: string) => {
      this._headerCells.set(column, null);
    });
  }

  addCell(columnName: string, cell: BoschUiCellDefDirective<DataType> | undefined): void {
    if (cell) {
      this._cells.set(columnName, cell);
    }
  }

  getCell(columnName: string): BoschUiCellDefDirective<DataType> | null {
    return this._cells.get(columnName) ?? null;
  }

  addHeaderCell(columnName: string, cell: BoschUiHeaderCellDefDirective<DataType> | undefined): void {
    if (cell) {
      this._headerCells.set(columnName, cell);
    }
  }

  getHeaderCell(columnName: string): BoschUiHeaderCellDefDirective<DataType> | null {
    return this._headerCells.get(columnName) ?? null;
  }
}
